import script from "./PrivacyPolicyModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrivacyPolicyModal.vue?vue&type=script&setup=true&lang=ts"

import "./PrivacyPolicyModal.vue?vue&type=style&index=0&id=3944b153&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3944b153"]])

export default __exports__